export default function SearchIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Search Icon</title>
      <path
        d="M9.58366 17.5013C13.9559 17.5013 17.5003 13.9569 17.5003 9.58464C17.5003 5.21238 13.9559 1.66797 9.58366 1.66797C5.21141 1.66797 1.66699 5.21238 1.66699 9.58464C1.66699 13.9569 5.21141 17.5013 9.58366 17.5013Z"
        stroke="#131313"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3337 18.3346L16.667 16.668"
        stroke="#131313"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
